!(function () {
  "use strict";
  customElements.get("video-background") ||
    customElements.define(
      "video-background",
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          ((this.videoId = this.querySelector("[data-video-id]")),
            (this.videoPlayer = this.querySelector("[data-video-player]")),
            (this.videoTemplate = this.querySelector("[data-video-template]")),
            (this.videoPlayButton =
              this.querySelector("[data-video-bg-play]") ||
              this.closest(
                "[data-video-slide]",
              )?.nextElementSibling.querySelector("[data-video-bg-play]")),
            this.videoId && this.renderVideo());
        }
        renderVideo() {
          ((this.videoObserver = new IntersectionObserver(
            (e, t) => {
              e.forEach((e) => {
                if (e.isIntersecting) {
                  const i = this.videoTemplate.innerHTML;
                  if (
                    ((this.videoPlayer.innerHTML = i),
                    (this.video = this.querySelector("[data-video-autoplay]")),
                    this.videoPlayer.classList.remove("is-loading"),
                    this.classList.add("is-paused"),
                    this.video)
                  ) {
                    const e = this.video.play();
                    (void 0 !== e &&
                      e
                        .then(() => {
                          this.videoPlayButton?.classList.add("hidden");
                        })
                        .catch(() => {
                          this.videoPlayButton?.classList.remove("hidden");
                        }),
                      this.listen());
                  }
                  t.unobserve(e.target);
                }
              });
            },
            {
              root: null,
              rootMargin: "300px",
              threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
            },
          )),
            this.videoObserver.observe(this.videoPlayer),
            this.videoPlayButton?.addEventListener("click", (e) => {
              (e.preventDefault(), this.video?.play());
            }));
        }
        listen() {
          (this.video.addEventListener("play", () => {
            (this.classList.remove("is-paused"),
              this.videoPlayButton?.classList.add("hidden"));
          }),
            this.addEventListener(
              "touchstart",
              () => {
                this.video.play();
              },
              { passive: !0 },
            ));
        }
        disconnectedCallback() {
          this.videoObserver && this.videoObserver.disconnect();
        }
      },
    );
})();
